import React from 'react'
import { ConfigProvider } from 'antd'
import koKR from 'antd/locale/ko_KR'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import { TenantConfigProvider } from './contexts/TenantConfigContext'
import { AuthProvider } from './contexts/AuthContext'
import AppRouter from './routes/AppRouter'

dayjs.locale('ko')

const App: React.FC = () => (
  <ConfigProvider
    locale={koKR}
    theme={{
      token: {
        colorPrimary: '#20489D',
        fontFamily: "'Noto Sans KR', 'Apple SD Gothic Neo', sans-serif",
        borderRadius: 6,
      },
    }}
  >
    {/* TenantConfigProvider가 가장 바깥 — /api/config 응답 전까지 로딩 표시 */}
    <TenantConfigProvider>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </TenantConfigProvider>
  </ConfigProvider>
)

export default App
